import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class GrupoProdutoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let gp = model;

        if (isNull(gp.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(gp.idgrupoprodutoerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        if (!validated) {
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true))
        }

        return validated;
    }

}